// extracted by mini-css-extract-plugin
module.exports = {"title":"Competition__title___28TcK","buttons":"Competition__buttons___3uSyu"};